<template>
  <v-simple-table fixed-header>
    <template v-slot:default>
      <thead>
        <tr>
          <th :colspan="3" class="grey lighten-2 font-weight-bold subtitle-1">
            <span>{{ $t("SKIT") }}</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="width-2">
            {{
              detailsSection.title ? detailsSection.title : $route.query.section
            }}
          </td>
          <td>
            <router-link
              :to="{
                name: 'Detail Skit',
                params: {
                  section: $route.params.section,
                  skit:
                    detailsSection.conversation &&
                    detailsSection.conversation.length
                      ? detailsSection.conversation[0].Id
                      : null,
                },
              }"
              >編集</router-link
            >
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>
<script>
export default {
  store: ["detailsSection"],
};
</script>
<style scoped>
::v-deep tr td {
  border: 1px solid #ccc;
  border-top: none;
}
::v-deep tr th {
  border: 1px solid #ccc;
  border-bottom: none;
}
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: #ffffff !important;
}
</style>